/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Rencontrez du monde, discutez, amusez-vous",
      "Numéro de téléphone incorrect",
      "Télécharger l'app",
      "Continuer avec Apple",
      "Continuer avec Facebook",
      "Continuer avec Google",
      "Se connecter",
      "Créer un compte",
      "Pour pouvoir continuer, merci de saisir les caractères ci-dessous dans le champ prévu à cet effet.",
      "Continuer",
      "Saisir les caractères",
      "Contrôle de sécurité",
      "Actualiser",
      "Créez un nouveau mot de passe, dont vous vous souviendrez facilement :",
      "Sauvegarder",
      "Confirmer le mot de passe",
      "Le mot de passe doit compter au moins {{num}} [[characters:num]]",
      "Mot de passe",
      "Créer un nouveau mot de passe",
      "Badoo - Le Blog",
      "Emploi",
      "Chat",
      "Villes",
      "Gérer les cookies",
      "Dépôt légal © 2006 - aujourd'hui. Bumble. Tous droits réservés.",
      "Apple et le logo Apple sont des marques déposées d'Apple Inc.{{__EOL__}}Google Play est une marque déposée de Google LLC.",
      "Télécharger",
      "Facebook",
      "Pour nous suivre :",
      "Centre d'aide",
      "Instagram",
      "Langue",
      "LinkedIn",
      "Présentation",
      "Badoo fait partie de Bumble Inc.",
      "Politique de Confidentialité",
      "Safety Centre",
      "Plan du site",
      "Loi sur l'esclavage moderne",
      "Conditions Générales d'Utilisation",
      "Twitter",
      "Saisissez votre adresse e-mail ou votre numéro, et nous vous enverrons les instructions pour créer un nouveau mot de passe.",
      "Obtenir un nouveau mot de passe",
      "Saisissez votre adresse e-mail ou votre numéro de téléphone",
      "Mot de passe oublié",
      "Modèles uniquement utilisés à des fins d'illustration",
      "Télécharger l'app",
      "Nous sommes enthousiastes à l'idée de proposer un soutien réaffirmé, une technologie efficace, une expérience plus sûre pour des relations basées sur une confiance accrue à tous nos membres. Notre engagement est total pour faire de Badoo l'appli qui propose des rencontres en toute confiance.",
      "Nous continuerons à innover en matière de technologie afin de répondre aux besoins des utilisateurs d'applications de rencontres, comme identifié dans ce rapport. Cela commencera par le lancement de <b><a href=\"{{url}}\">Deception Detector™</a></b>, un modèle d'apprentissage automatique qui a démontré un taux de <b>précision de 99,5%</b> dans la lutte contre les spams, les escroqueries et les faux comptes.",
      "Notre <b>engagement</b> est d'utiliser l'Intelligence Artificielle (IA) de manière responsable, en assurant que l'intelligence humaine soit toujours prioritaire et que les capacités de l'IA ne mettent pas en péril le caractère <b>authentique</b> de notre communauté ;",
      "Nous ne contribuerons plus à la création de tendances qui nourrissent des <b>perceptions</b> et des <b>comportements négatifs</b> ;",
      "Nous travaillerons pour identifier les <b>mauvais comportements</b> dans le processus de rencontre, afin de minimiser leur impact sur le bien-être de notre communauté ;",
      "Nous ne travaillerons qu'avec des talents qui, d'après nous, sont <b>authentiques</b> et <b>réalistes</b> dans leur manière de se présenter en ligne ;",
      "Accéder à Badoo",
      "Nos engagements pour une confiance accrue :",
      "Nous avons publié ce rapport pour les personnes désireuses de faire des rencontres, pour les communautés de rencontres et pour les plateformes en ligne, afin de faire profiter à tout le monde des résultats de nos études. Notre but : permettre aux personnes de vivre des expériences de rencontres bienveillantes et agréables, comme jamais auparavant.",
      "Chez Badoo, nous savons qu'il reste du travail à accomplir. Nos équipes ont étudié des résultats d'études et modifient certaines choses pour que nous jouions pleinement notre rôle. Mais il y a aussi des engagements immédiats que nous avons décidé de prendre.",
      "À un moment charnière où nous pensons que les relations humaines n'ont jamais été aussi précieuses et où la confiance des personnes dans leur capacité à nouer des relations n'a jamais été aussi importante, nous avons créé un <b>Rapport sur la confiance dans les rencontres</b>, une première sur le marché des rencontres en ligne.",
      "Télécharger le rapport",
      "Badoo a toujours été pionnier dans le domaine des rencontres, en créant l'une des premières plateformes de rencontres en ligne au monde et en étant la première à atteindre la barre des 100 millions de téléchargements.",
      "Le rapport détaille les comportements, les attitudes et les influences qui ont un impact négatif sur les rencontres et propose des conseils d'experts sur la manière dont nous pouvons mieux profiter des aspects positifs des applis de rencontres, mais aussi mieux gérer, modifier ou éviter leurs aspects négatifs.",
      "Faire des rencontres volontaires en ligne ou en personne lors desquelles on peut se détendre, profiter de l'instant et être soi-même",
      "Être en mesure d'ignorer ce que l'on voit sur les réseaux sociaux et se concentrer sur ce qui fonctionne pour soi",
      "Sentir que la personne que l'on rencontre ou à qui on parle est bien réelle",
      "Être au clair avec ses propres intentions et avoir le sentiment que la personne que l'on rencontre est aussi sincère",
      "Réduire la paranoïa et l'hypervigilance concernant les comportements négatifs lors des rencontres",
      "Les ingrédients-clés pour faire des rencontres en toute confiance sont :",
      "Nous croyons qu'il s'agit de la plus grande barrière dans l'univers des rencontres et notre engagement est de faire tomber cette barrière. Chaque année, plutôt que de nous focaliser sur les tendances en matière de rencontres, nous évaluerons notre propre capacité à proposer des rencontres en toute confiance et continuerons à étudier les barrières auxquelles les personnes se heurtent lorsqu'elles cherchent à faire des rencontres.",
      "Les résultats de nos études conduiront à des engagements et à des innovations annuels sur la confiance en matière de rencontres au sein de notre produit, afin de minimiser les expériences qui nuisent à la confiance des personnes. Notre objectif est de faire des rencontres en ligne une expérience bienveillante, <b><u><a href=\"{{url}}\">plus sûre</a></u></b> et plus utile pour tous ceux qui cherchent des connexions qui ont du sens. Retrouvez ci-dessous nos engagements pour 2024.",
      "Découvrez nos engagements pour des rencontres en toute confiance",
      "Le rapport prouve sans équivoque que la confiance en matière de rencontres est au plus bas pour de nombreux célibataires.",
      "Pas besoin d'attendre que ça matche.{{__EOL__}}{{__EOL__}}Lancez-vous dans de vraies discussions : celles qui permettent de vraiment faire connaissance.",
      "Envie de discuter maintenant ?",
      "En vous inscrivant, vous acceptez nos <a class=\"link\" href=\"{{terms_url}}\">Conditions Générales d'Utilisation</a>. Découvrez comment nous utilisons vos données en consultant notre <a class=\"link\" href=\"{{privacy_url}}\">Politique de Confidentialité</a>.",
      "Une expérience de rencontres authentique <br />qui vous permet de rester vous-même.",
      "Des rencontres en toute confiance.",
      "Ou",
      "Vous avez déjà un compte ?",
      "Inscrivez-vous avec votre e-mail ou votre numéro de téléphone",
      "Vous savez ce que vous recherchez.{{__EOL__}}Assumez vos intentions.",
      "Une simple envie de papoter ? Aucun problème.{{__EOL__}}Une réelle envie de stabilité ? On adore.{{__EOL__}}{{__EOL__}}Et si vous changez d'avis, ça marche aussi.",
      "Des rencontres",
      "Une histoire sérieuse",
      "Discuter",
      "Rencontrez des personnes qui recherchent la même chose que vous.",
      "{{name}}, {{age}} ans",
      "Assurer votre sécurité est notre priorité.",
      "Notre Centre de sécurité contient toutes les infos et les conseils dont vous avez besoin pour faire des rencontres en toute confiance.",
      "Consultez notre Centre de sécurité",
      "Votre sécurité<br/>passe avant tout.",
      "Je savais dès le début que ça marcherait entre nous...",
      "Au départ, je ne cherchais pas vraiment quelque chose de sérieux...",
      "Le meilleur conseil sur l'appli Badoo, c'est d'être soi‑même...",
      "Jolies rencontres Badoo",
      "Plus d'histoires de jolies rencontres",
      "{{num}}__CUT__Note",
      "App Store d'Apple",
      "Faites-nous confiance. Nous avons formé des millions et des millions (et des millions) de couples depuis 2006.",
      "Plus de {{num}} millions de téléchargements",
      "Plus de {{num}} millions",
      "Google Play Store",
      "On connaît notre métier.",
      "Connectez-vous avec votre e-mail ou votre numéro de téléphone",
      "Saisissez votre mot de passe",
      "Mot de passe oublié ?",
      "S'inscrire",
      "Vous n'avez pas encore de compte ?",
      "Connexion",
      "Créer un compte"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caractères"
            ],
            "singular": [
                  "caractère"
            ]
      },
      "day": {
            "plural": [
                  "jours"
            ],
            "singular": [
                  "jour"
            ]
      },
      "hour": {
            "plural": [
                  "heures"
            ],
            "singular": [
                  "heure"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "mois"
            ],
            "singular": [
                  "mois"
            ]
      },
      "second": {
            "plural": [
                  "secondes"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "ans"
            ],
            "singular": [
                  "an"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
